<template>
<div class="chapter">
<div class="inner_page">
<h1 class="block_7" id="id_Toc433889306" lang="en">Sommaire</h1>
<p class="block_8"><span class="text_1"></span><a class="text_2">Chapitre 1</a></p>
<p class="block_8"><a class="text_2">Chapitre 2</a></p>
<p class="block_8"><a class="text_2">Chapitre 3</a></p>
<p class="block_8"><a class="text_2">Chapitre 4</a></p>
<p class="block_8"><a class="text_2">Chapitre 5</a></p>
<p class="block_8"><a class="text_2">Chapitre 6</a></p>
<p class="block_8"><a class="text_2">Chapitre 7</a></p>
<p class="block_8"><a class="text_2">Chapitre 8</a></p>
<p class="block_8"><a class="text_2">Chapitre 9</a></p>
<p class="block_8"><a class="text_2">Chapitre 10</a></p>
<p class="block_8"><a class="text_2">Chapitre 11</a></p>
<p class="block_8"><a class="text_2">Chapitre 12</a></p>
<p class="block_8"><a class="text_2">Épilogue</a></p>
<p class="block_9"><span class="text_3"></span><span class="text_4"><br class="calibre1" id="calibre_pb_2"/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_002.vue?ae1a03b4